import React from "react";
//#region redux
//#endregion
//#region types
import { SelfInvoiceWizardQuickSelectionProps } from "models/propTypes/selfInvoicePropTypes";
import { TranslationKeys } from "translations";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { InlineLabelDatePicker } from "components/common";
import { Portal } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceWizardQuickSelection: React.FC<SelfInvoiceWizardQuickSelectionProps> = (props) => {
  const { connect } = props;
  const quickSelectionMount = document.getElementById(HTMLConstants.WizardQuickSelectionPortalId);

  const invoiceDateProps = connect("invoiceDate");

  return (
    <Portal container={quickSelectionMount}>
      <Grid container item direction="row">
        <InlineLabelDatePicker
          {...invoiceDateProps}
          onChange={(date?: Date) => invoiceDateProps.setValue(date, true)}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.InvoiceDate)}
        />
      </Grid>
    </Portal>
  );
};

export default SelfInvoiceWizardQuickSelection;
